import lodash, { lowerFirst } from 'lodash'
import { router } from 'umi'
import { getPages, init } from '@xiaoduo/x-data/utils'
import priCenterSdk from '@xiaoduo/pricentersdk'
import { notification, message } from 'antd'
import model, { ModelWithState } from '@/utils/model'
import { getMenuState, getAllRoutes } from '@/utils/route'
import { getDepartmentOptions } from '@/utils/department'
import * as common from '@/services/common'
import { getPageQuery, MYD_URL_TB, MYD_URL_JD, isNewLayout, isTest } from '@/utils/utils'
import { platforms } from '@/configs'
import { DvaState } from '@/types/react-redux'
import { ShopItem } from '@/types/shop'
import { DepartmentItem, EmployeeList } from '@/pages/system/department/data'
import { AccountList } from '@/types/account'
import { StandardList, QuestionList } from '@/pages/standard/list/data'
import { fetchDialogMessages } from '@/components/QaMessageModal/service'
import { copyPolyfill } from '../layouts/BasicLayout/components/GlobalHeader/HelpCenter'
import { cascaderValueMap } from '../pages/alarm/utils'
import { handleDataforceV2 } from '@/utils/handleDataforceV2'

init({
  debug:
    window.location.host?.startsWith('mc-mini-test-mini-cond') ||
    window.location.host?.startsWith('localhost') ||
    window.location.host?.includes('dev-lane') ||
    window.location.host?.startsWith('dev.') ||
    window.location.host?.startsWith('pro.'),
})
export interface Route {
  icon?: string
  name?: string
  path?: string
  component?: string
  hideInMenu?: boolean
  routes?: Route[]
}
export interface Menu {
  icon?: string
  name?: string
  path?: string
  children?: Menu[]
}

export interface ShopOption extends ShopItem {
  value: string
  label: string
  children?: ShopOption[]
}
export interface departmentOption extends DepartmentItem {
  value: string
  label: string
  children?: departmentOption[]
}

export interface ModelState {
  routes: {
    [key: string]: Route
  }
  breadcrumbs: {
    [key: string]: Route
  }
  menus: Menu[]
  firstRoute: Route

  // 标准
  standards: any[]

  // 店铺相关
  platformShops: (ShopItem & Op)[]
  shops: ShopOption[]
  // 分组
  departments: departmentOption[]
  // 客服
  employees: any[]
  allEmployees: any[]
  employeesMap: Map<string, string>
  // 子账号
  snicks: any[]
  // 质检人员
  accounts: any[]
  // 场景标签
  sceneLabels: any[]
  labelsMap: Map<string, string>
  labelsValMap: Map<string, string[]>
  // 获取页面内容
  xdata: any[]
  features: { [key: string]: any }
  allFeatures: Record<string, any> // 所有页面权限，不区分平台，用于权限管理
  // 版本号
  version_code: string
  dataRoleShops: any[]
  dataRoleSnicks: any[]
  getCurrentUserAuth: string[]
  taskAlertModalVisible: boolean
  taskDrawerVisible: boolean
  allIndustry: any[]
  allIndustryNumber: number
  caseLabels: ShopOption[]
  caseMap: {
    // valueMap用于将后端返回的数据转换成Cascader组件需要的数据格式
    valueMap: Map<string, string[]>
    nameMap: Map<string, string>
  }
  showAIGC: boolean // 展示大模型推理功能
}

export interface IPage {
  id: string
  name: string
  primary_pages?: IPage[]
  secondary_pages?: SecondPages[]
}

export interface SecondPages {
  hidden: boolean
  id: string
  layout: string
  name: string
}

// 旧布局-包含的路由 删除
const routesMap: Record<string, string> = {
  数据监控: '/data',
  消费者分析: '/voc',
  '64cb196b544b90b1e25151f1': '/meidi',
  '65ae2331caedb3e32d0b0651': '/meidi2',
  '660117d78b749bc0065b6360': '/pddReports',
  质检报表: '/qcTable',
}

// 新布局包含的路由
const routesMapV2: Record<string, string> = {
  工作台: '/workbench',
  实时风险监控: '/riskMonitor',
  人工质检: '/qcManage/check',
  质检分析: '/qcManage/check',
  质培联动: '/qcManage/train',
  质检报表: '/reportCenter/qcReport',
  客服评价满意度: '/reportCenter',
  // 分析洞察Agent: '/reportCenter/aiInsight',
  质检效果监控: '/system/effectMonitor',
  报表中心: '/reportCenter',
}

const childsMap: Record<string, string> = {
  '64213b267a45874ba903e9ac': '/voc/hot',
  '6668021f3b1c08954549cc52': '/voc/hot',
  '64ccc9ee544b90b1e251529f': '/voc/analysis',
  '6697379622ab809971103c19': '/voc/analysis',
  '64ccca23544b90b1e25152ad': '/voc/analysis',
  '655ad09622328c3b7467acfe': '/voc/hot',
  '6697390e22ab809971103d3d': '/voc/hot',
}

const childsMapV2: Record<string, string> = {
  // 告警大屏
  '6690db299ed071e51721831e': '/workbench',
  // 实时风险监控
  '66922f2822ab809971103a55': '/riskMonitor',
  '66922f2822ab809971103a4f': '/riskMonitor',
  '66922f2822ab809971103a49': '/riskMonitor',
  '6691f6d522ab80997110364b': '/riskMonitor',
  // 报表中心：
  '696e39a4895d8a4fdd0f9b5d': '/reportCenter',
  '69844a6237998ed829ff44b5': '/reportCenter',
  '69bbad6ddb87e97497126968': '/reportCenter',
  '69c2793903e3bdd4b7dcfc17': '/reportCenter',

  // 质检报表
  '69018eb8e48628355d7a3a60': '/reportCenter/qcReport',
  '69128b08be2024d466e4befb': '/reportCenter/qcReport',
  '6909f4f7e48628355d7a53ff': '/reportCenter/qcReport',
  // 客服评价满意度
  '67d2461ce63366f0474b20b0': '/reportCenter', //tb
  '6692264d22ab8099711037a3': '/reportCenter', //jd
  // 质检效果监控
  '697086af895d8a4fdd0faf3f': '/system/effectMonitor',
  // 人工质检诊断报告
  '68a691a6ad2af9f81792f636': '/qcManage/check',
  '68a692b3ad2af9f81792f758': '/qcManage/check',
  // 质培联动-会话案例
  '68e1234567890abcdef12347': '/qcManage/train',
}

const UserModel: ModelWithState<ModelState> = model.extend({
  namespace: 'global',
  state: {
    // 路由相关
    showNoticeItem: null, // 当前展示的通知
    routes: {},
    breadcrumbs: {},
    menus: [],
    firstRoute: {},
    standards: [],
    platformShops: [],
    shops: [],
    departments: [],
    employees: [],
    allEmployees: [],
    employeesMap: new Map<string, string>(),
    snicks: [],
    accounts: [],
    sceneLabels: [],
    labelsMap: new Map<string, string>(),
    labelsValMap: new Map<string, string[]>(),
    xdata: [],
    features: {},
    dataRoleShops: [], // 数据权限里面的shops
    dataRoleSnicks: [], // 数据权限里面的snicks
    getCurrentUserAuth: [], // 获取当前用户的权限
    taskAlertModalVisible: false,
    taskDrawerVisible: false,
    allIndustry: [],
    allIndustryNumber: 0,
    helpCenterDetail: {},
    caseLabels: [],
    caseMap: {
      valueMap: new Map(),
      nameMap: new Map(),
    },
    showAIGC: false, // 展示大模型推理功能
  },
  effects: {
    *initData(action, { put }) {
      yield put({ type: 'initMenu' })
      yield put({ type: 'fetchStandards' })
      yield put({ type: 'fetchShops' })
      yield put({ type: 'fetchDataRoleShopsOrSnicks' })
      yield put({ type: 'fetchDepartments' })
      yield put({ type: 'fetchEmployees' })
      yield put({ type: 'fetchSnicks' })
      yield put({ type: 'fetchAccounts' })
      yield put({ type: 'fetchSceneLabels' })
      yield put({ type: 'fetchCaseLabels' })
    },
    // 渲染x-data的页面内容
    *initMenu(action, { put }) {
      yield put({ type: 'fetchDataRoleCenter', payload: { content: 'global' } })
    },
    // 对接权限中心
    *fetchDataRoleCenter({ payload }, { call, put, select }) {
      const { content } = payload
      const {
        company_info = {},
        screenAuth,
        role_info,
        platform,
      } = yield select((store: DvaState) => store.user)
      // 取xdata
      let xdata = []
      const xdataRes = yield call(getPages, 'xqc')
      const vocRes = yield call(getPages, 'voc')
      const meidiRes = yield call(getPages, 'MDTG')

      const mergeDataforcePages = [
        ...(xdataRes?.items ?? []),
        ...(vocRes?.items ?? []),
        ...(meidiRes?.items ?? []),
      ]

      // ?? 是默认值
      if (isNewLayout) {
        xdata =
          handleDataforceV2(mergeDataforcePages, platform).map((item: IPage) => {
            const munuPath = routesMapV2?.[item.id] ?? routesMapV2?.[item.name] ?? `/${item.id}`
            return {
              ...item,
              path: munuPath,
              routes: item.primary_pages
                ?.filter((i) => (i.secondary_pages || [])?.length > 0)
                .map((i) => ({
                  path: `${childsMapV2?.[i.id] ? childsMapV2?.[i.id] : munuPath}/${i.id}`,
                  ...i,
                })),
            }
          }) ?? []
      } else {
        xdata =
          mergeDataforcePages.map((item: IPage) => {
            const munuPath = routesMap?.[item.id] ?? routesMap?.[item.name] ?? `/${item.id}`
            return {
              ...item,
              path: munuPath,
              routes: item.primary_pages
                ?.filter((i) => (i.secondary_pages || [])?.length > 0)
                .map((i) => ({
                  path: `${childsMap?.[i.id] ? childsMap?.[i.id] : munuPath}/${i.id}`,
                  ...i,
                })),
            }
          }) ?? []
      }

      // 权限中心
      const features: Record<string, number> = {}
      const allFeatures: Record<string, number> = {}
      const { code, data } = yield priCenterSdk.init({
        token: company_info.pri_center_token,
        host: isTest ? '//console-dev-lane.xiaoduoai.com' : '//console.xiaoduoai.com',
        appId: 'mc',
      })
      if (code === 0 && data) {
        const hasNewLayout = data.features?.includes('mc.newLayout')
        // 只有当用户没有手动设置过版本时，才根据权限自动设置默认版本
        const userSetVersion = localStorage.getItem('ums_layoutVerson')
        if (!userSetVersion) {
          // 用户未手动切换过版本，根据权限设置默认版本
          localStorage.setItem('ums_layoutVerson', hasNewLayout ? 'v2' : 'v1')
        }
        // 如果当前版本与预期不符且用户未手动设置过，才自动跳转
        if (hasNewLayout && !isNewLayout && !userSetVersion) {
          window.location.href = window.location.origin
        }
        if (!hasNewLayout && isNewLayout && !userSetVersion) {
          window.location.href = window.location.origin
        }
        data.features?.forEach((f: string) => {
          const ss = f.split('.')
          features[`/${ss.slice(1).join('/')}`] = 1
          allFeatures[`/${ss.slice(1).join('/')}`] = 1
        })

        if (isNewLayout) {
          // 新布局下面的菜单放在了其他位置
          features['/system/caseLabel'] = 0
          features['/system/sceneLabel'] = 0
          features['/system/eliminateLabels'] = 0

          allFeatures['/system/caseLabel'] = 0
          allFeatures['/system/sceneLabel'] = 0
          allFeatures['/system/eliminateLabels'] = 0
        } else {
          // 旧布局--下面删除
          features[MYD_URL_TB] = 1
          features[MYD_URL_JD] = 1
          // 满意度报表（淘宝 京东）
          if (platform !== 'tb') {
            features[MYD_URL_TB] = 0
            features['/629f04d38b3dc3b2fe7a915d/629f05338b3dc3b2fe7a91c4'] = 0
          }
          if (platform !== 'jd' && features[MYD_URL_JD]) {
            features[MYD_URL_JD] = 0
            features['/629f04d38b3dc3b2fe7a915d/62dfcae1b6a05acfe2448b5b'] = 0
          }
        }

        // data.features?.includes('mc.llm_rule_check')=true是大模型推理功能的白名单客户
        yield put({
          type: 'setState',
          payload: { showAIGC: !!data.features?.includes('mc.llm_rule_check') },
        })
      } else {
        notification.error({ message: '权限系统请求错误' })
      }
      if (content === 'user') {
        const filterPaths = screenAuth ? [] : ['/screen']
        const { firstRoute } = getMenuState(role_info, xdata, features, filterPaths)

        const params = getPageQuery()
        const { redirect } = params as { redirect: string }
        if (data.is_expired) {
          message.error('账号授权已到期，请联系管理员')
        } else {
          router.replace(redirect || firstRoute.path)
        }
      } else if (data.is_expired) {
        message.error('账号授权已到期，请联系管理员')
        router.replace('user/login')
      } else {
        yield put({
          type: 'setState',
          payload: { xdata, features, allFeatures, version_code: data.version_code },
        })
        yield put({ type: 'updateMenu' })
      }
    },
    *updateMenu(action, { call, put, select }) {
      const { role_info, screenAuth, platform } = yield select((store: DvaState) => store.user)
      const { xdata, features } = yield select((store: DvaState) => store.global)
      const filterPaths = screenAuth ? [] : ['/screen']
      const { menus, breadcrumbs, routes, firstRoute } = getMenuState(
        role_info,
        xdata,
        features,
        filterPaths
      )

      if (firstRoute.path && window.location.pathname === '/' && isNewLayout) {
        router.replace(firstRoute.path)
      }
      const copiedMenus = JSON.parse(JSON.stringify(menus))
      /***—————————————————旧布局- 删除 - satrt———————————————————————————————————***/
      if (!isNewLayout) {
        try {
          copiedMenus.map((item) => {
            if (item.name === '数据监控') {
              item.children.map((item) => {
                if (item.name === '会话量大屏') {
                  item.path = '/data/669097439ed071e517215fb1'
                  features['/data/669097439ed071e517215fb1'] = 1
                }
                if (item.name === '告警大屏') {
                  item.path = '/data/6690db299ed071e51721831e'
                  features['/data/6690db299ed071e51721831e'] = 1
                }
                if (item.name === '质检诊断报告') {
                  if (platform === 'tb') {
                    item.path = '/data/67dbbb9ce63366f0474b2da5'
                    features['/data/67dbbb9ce63366f0474b2da5'] = 1
                  } else {
                    item.path = '/data/6690df069ed071e5172185d3'
                    features['/data/6690df069ed071e5172185d3'] = 1
                  }
                }
              })
            }
            if (item.name === 'VOC') {
              item.children.map((item) => {
                if (item.name === '商品咨询热点') {
                  item.children.map((item) => {
                    if (item.name === '商品热点报告') {
                      if (platform === 'tb') {
                        item.path = '/voc/hot/67de683eac92a95fb638f3bd'
                        features['/voc/hot/67de683eac92a95fb638f3bd'] = 1
                      } else {
                        item.path = '/voc/hot/6668021f3b1c08954549cc52'
                        features['/voc/hot/6668021f3b1c08954549cc52'] = 1
                      }
                    }
                    if (item.name === '商品咨询统计') {
                      if (platform === 'tb') {
                        item.path = '/voc/hot/67de683eac92a95fb638f3c9'
                        features['/voc/hot/67de683eac92a95fb638f3c9'] = 1
                      } else {
                        item.path = '/voc/hot/6697390e22ab809971103d3d'
                        features['/voc/hot/6697390e22ab809971103d3d'] = 1
                      }
                    }
                  })
                }
                if (item.name === '商品流失分析') {
                  item.children.map((item) => {
                    if (item.name === '商品流失报告') {
                      if (platform === 'tb') {
                        item.path = '/voc/analysis/67de683eac92a95fb638f3c0'
                        features['/voc/analysis/67de683eac92a95fb638f3c0'] = 1
                      } else {
                        item.path = '/voc/analysis/6697379622ab809971103c19'
                        features['/voc/analysis/6697379622ab809971103c19'] = 1
                      }
                    }
                  })
                }
              })
            }
            if (item.name === '质检报表') {
              item.children.map((item) => {
                if (item.name === '质检明细报表' && platform === 'tb') {
                  console.log('质检明细报表', item)

                  item.path = '/qcTable/67de4ee9ac92a95fb638f316'
                  features['/qcTable/67de4ee9ac92a95fb638f316'] = 1
                } else if (item.name === '质检明细报表') {
                  item.path = '/qcTable/66a1fd3b22ab809971104e06'
                  features['/qcTable/66a1fd3b22ab809971104e06'] = 1
                }
                if (item.name === '实时告警报表') {
                  item.path = '/qcTable/6691f6d522ab80997110364b'
                  features['/qcTable/6691f6d522ab80997110364b'] = 1
                }
              })
            }
            if (item.name === '客户评价满意度' && platform === 'tb') {
              item.path = '/629f04d38b3dc3b2fe7a915d/67d2461ce63366f0474b20b0'
              features['/629f04d38b3dc3b2fe7a915d/67d2461ce63366f0474b20b0'] = 1
            }
            if (item.name === '客户评价满意度' && platform === 'jd') {
              item.path = '/629f04d38b3dc3b2fe7a915d/6692264d22ab8099711037a3'
              features['/629f04d38b3dc3b2fe7a915d/6692264d22ab8099711037a3'] = 1
            }
            if (item.name === '实时告警') {
              item.children.map((item) => {
                if (item.name === '全局告警统计') {
                  item.path = '/60b87bb27b0e79e09606bf84/66922f2822ab809971103a49'
                  features['/60b87bb27b0e79e09606bf84/66922f2822ab809971103a49'] = 1
                }
                if (item.name === '平台告警统计') {
                  item.path = '/60b87bb27b0e79e09606bf84/66922f2822ab809971103a4f'
                  features['/60b87bb27b0e79e09606bf84/66922f2822ab809971103a4f'] = 1
                }
                if (item.name === '店铺实时告警') {
                  item.path = '/60b87bb27b0e79e09606bf84/66922f2822ab809971103a55'
                  features['/60b87bb27b0e79e09606bf84/66922f2822ab809971103a55'] = 1
                }
              })
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
      /***—————————————————旧布局- 删除 - end ———————————————————————————————————***/

      // 计算所有的权限
      const getCurrentUserAuth = getAllRoutes(features, xdata, filterPaths)

      yield put({
        type: 'setState',
        payload: {
          menus: copiedMenus,
          routes,
          breadcrumbs,
          firstRoute,
          getCurrentUserAuth: [...getCurrentUserAuth, '/404', '/403'],
        },
      })
    },

    *fetchIndustry({ payload }, { call, put, select }) {
      const { allIndustry: pre_allIndustry } = yield select((store: DvaState) => store.global)
      const response = yield call(common.fetchIndustry, payload)
      const allIndustry = ((lodash.get(response, 'data.questions', []) || []) as QuestionList).map(
        (item) => ({
          value: item?.qids?.join(),
          render_qid: item,
          label: `${item.question}(${item.shops?.join(',')})`,
          ...item,
        })
      )
      yield put({
        type: 'setState',
        payload: {
          allIndustry: [...pre_allIndustry, ...allIndustry],
          allIndustryNumber: lodash.get(response, 'data.total'),
        },
      })
    },

    // 获取质检标准
    *fetchStandards(action, { call, put }) {
      const response = yield call(common.fetchStandards, { current_page: 1, page_size: 100 })
      const standards = ((lodash.get(response, 'data.qc_norms', []) || []) as StandardList).map(
        (item) => ({
          value: item.id,
          label: item.name,
          ...item,
        })
      )

      yield put({ type: 'setState', payload: { standards } })
    },

    // 店铺列表
    *fetchShops(_, { call, put, select }) {
      const { platform } = yield select((store: DvaState) => store.user)
      const { data } = yield call(common.fetchShops)
      const platformMaps = (data.shops || []).reduce((cache: any, item) => {
        if (!cache[item.platform]) {
          cache[item.platform] = []
        }
        cache[item.platform].push({
          value: item.seller_nick,
          label: item.seller_nick,
          ...item,
        })
        return cache
      }, {})

      const platformShops = platforms
        .map((item) => ({ ...item, children: platformMaps[item.value] }))
        .filter((item) => {
          return item.children && item.children.length
        })
      const shops = (platformShops.find((item) => item.value === platform) || {})!.children || []
      yield put({ type: 'setState', payload: { platformShops, shops } })
    },

    *fetchDataRoleShopsOrSnicks(_, { call, put, select }) {
      const { platform, data_permit } = yield select((store: DvaState) => store.user)
      const platformShopMaps = (data_permit?.shops || []).reduce((cache: any, item) => {
        if (!cache[item.platform]) {
          cache[item.platform] = []
        }
        cache[item.platform].push({
          value: item.seller_nick,
          label: item.plat_seller_nick || item.seller_nick,
          ...item,
        })
        return cache
      }, {})

      const platformSnicksMaps = (data_permit?.snicks || []).reduce((cache: any, item) => {
        if (!cache[item.platform]) {
          cache[item.platform] = []
        }
        cache[item.platform].push({
          value: item.snick,
          label: item.snick,
          ...item,
        })
        return cache
      }, {})

      const platformShops = platforms
        .map((item) => ({ ...item, children: platformShopMaps[item.value] }))
        .filter((item) => {
          return item.children && item.children.length
        })

      const platformSnicks = platforms
        .map((item) => ({ ...item, children: platformSnicksMaps[item.value] }))
        .filter((item) => {
          return item.children && item.children.length
        })

      const dataRoleShops =
        (platformShops.find((item) => item.value === platform) || {})!.children || []

      const dataRoleSnicks =
        (platformSnicks.find((item) => item.value === platform) || {})!.children || []

      yield put({ type: 'setState', payload: { dataRoleShops, dataRoleSnicks } })
    },

    // 分组列表
    *fetchDepartments(action, { call, put }) {
      const response = yield call(common.fetchDepartments)
      yield put({
        type: 'setState',
        payload: { departments: getDepartmentOptions([response.data.deps]) },
      })
    },

    // 客服列表
    *fetchEmployees(action, { call, put }) {
      const result = yield call(common.fetchEmployees)
      const employeesMap = new Map<string, string>()
      const allEmployees = (lodash.get(result, 'data.list', []) as EmployeeList).map((item) => {
        employeesMap.set(item.id, item.username)

        return {
          value: item.id,
          label: item.username,
          disabled: item.status !== 1,
          ...item,
        }
      })

      yield put({
        type: 'setState',
        payload: {
          allEmployees,
          employeesMap,
          employees: allEmployees.filter((item) => item.status === 1),
        },
      })
    },

    // 子账号列表
    *fetchSnicks(action, { call, put }) {
      const result = yield call(common.fetchSnicks)
      const snicks = (lodash.get(result, 'data.snicks', []) as string[]).map((item) => ({
        value: item.snick,
        label: item.plat_snick,
      }))
      yield put({ type: 'setState', payload: { snicks } })
    },

    // 质检人员
    *fetchAccounts(action, { call, put }) {
      const result = yield call(common.fetchAccounts)
      const accounts = (lodash.get(result, 'data.accounts', []) as AccountList).map((item) => ({
        value: item.account_id,
        label: item.account_name,
        ...item,
      }))
      yield put({ type: 'setState', payload: { accounts } })
    },

    // 场景标签
    *fetchSceneLabels(action, { call, put }) {
      const response = yield call(common.fetchSceneLabels, { all: true })
      const labelsMap = new Map<string, string>()
      const labelsValMap = new Map<string, string[]>()
      const sceneLabels = (lodash.get(response, 'data.labels') || []).map((item: any) => {
        labelsMap.set(item.label_id, item.name)
        labelsValMap.set(item.label_id, [item.label_id])

        return {
          value: item.label_id,
          label: item.name,
          disabled: item.delete,
          ...item,
          children: (item.sub_label || []).map((subItem: any) => {
            labelsMap.set(subItem.label_id, `${item.name}/${subItem.name}`)
            labelsValMap.set(subItem.label_id, [item.label_id, subItem.label_id])

            return {
              value: subItem.label_id,
              label: subItem.name,
              disabled: subItem.delete,
              ...subItem,
            }
          }),
        }
      })
      yield put({ type: 'setState', payload: { sceneLabels, labelsMap, labelsValMap } })
    },

    *fetchCaseLabels(_, { call, put }) {
      const res = yield call(common.fetchCaseLabels)
      const nameMap = new Map<string, string>()
      const caseLabels = (res?.data?.case_labels || []).map((root) => ({
        value: root.case_label_id,
        label: root.name,
        children: (root.subs || []).map((sub) => ({
          value: sub.case_label_id,
          label: sub.name,
          children: (sub.case_views || []).map((item) => {
            nameMap.set(item.id, item.name || '-')
            return {
              value: item.id,
              label: item.name || '-',
            }
          }),
        })),
      }))

      const caseMap = {
        valueMap: cascaderValueMap(caseLabels),
        nameMap,
      }

      yield put({
        type: 'setState',
        payload: {
          caseLabels,
          caseMap,
        },
      })
    },

    *fetchHelpCenter(action, { call, put }) {
      const res = yield call(common.fetchHelpDoc)
      yield put({ type: 'setState', payload: { helpCenterDetail: res?.data ?? {} } })
    },
    *saveHelpCenter({ payload }, { call, select, put }) {
      const { helpCenterDetail } = yield select((store: DvaState) => store.global)
      const id = helpCenterDetail?.id
      const res = yield call(common.saveHelpDoc, {
        id,
        ...payload,
      })
      if (res.code === 0) {
        message.success('修改成功！')
      }
      yield put({ type: 'fetchHelpCenter' })
    },
    *copyMessageId({ payload }, { call, select }) {
      const { dialogId, wipeId, platform, isEliminateModal } = payload
      const companyId = yield select((store: DvaState) => store.user.company_info.company_id)
      let { beginTime } = payload

      // 告警页面的复制会话，需要获取时间
      if (!beginTime) {
        const res = yield call(fetchDialogMessages, { dialogId })
        beginTime = res?.data?.dialogInfo?.beginTimestamp
      }

      let searchQuery = `id=${dialogId}&platform=${platform}&company_id=${companyId}`

      if (isEliminateModal) {
        searchQuery += `&wipeId=${wipeId}`
      } else {
        searchQuery += `&begin=${beginTime}`
      }

      copyPolyfill(
        `${origin}/${isEliminateModal ? `${isNewLayout ? '/system/effectMonitor/eliminateLabels' : '/system/eliminateLabels'}` : 'dialog'}?${searchQuery}`
      )
      message.success(`操作成功！已将内容自动复制到剪切板。请尽快登录并查看。`)
    },
    //
  },

  reducers: {},
  subscriptions: {},
})

export default UserModel
